define('bizzabo/views/DynamicallyGeneratedView',[
    'backbone',
    'bizzabo/consts'
], function(
    Backbone,
    Consts
    ) {

    var DynamicallyGeneratedView = Backbone.View.extend({

        /**
         * overwrite in case async init is needed
         */
        prepare : function() {
            this.loadingSuccess();
        },

        loadingSuccess : function(model, response) {
            Backbone.trigger(Consts.Notifications.mainPage.PREPARE_SUCCESS);
        },

        loadingFailure : function(model, response) {
            Backbone.trigger(Consts.Notifications.mainPage.PREPARE_FAILURE, response);
        },

        failedToLoadErrorMsg : "Something went wrong while loading the page"
    });

    return DynamicallyGeneratedView;
});

